import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';
import { formatWorkDuration } from '../../util/dates';

import closeIcon from '../../assets/img/x.svg';
import DetailStats from './DetailStats';

function stageTime(d, blockedList, blockedTime) {
  const blockedListTime = blockedList ? blockedList.blockedTime : 0;
  if (blockedTime === 'non-blocked') {
    return d.cycleTime - blockedListTime;
  }
  if (blockedTime === 'blocked') {
    return blockedListTime;
  }
  return d.cycleTime;
}

export class FEDetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    if (props.test) {
      this.state = {
        show: true,
        data: this.props.data
      };
    } else {
      this.state = {
        show: false,
        data: {}
      };
    }

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data
      });
    }
  }

  handleClose() {
    this.setState({
      show: false,
      data: {}
    });

    trackChartPointDetailsView('fe', false);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  renderDetail(d, y, blockedList, blockedTime, label, blockers, isLongest) {
    const ct = formatWorkDuration(stageTime(d, blockedList, blockedTime), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const showBlockerInfo = blockers !== false && blockedTime === 'all';
    return (
      <p key={y} className={`detail-stage ${isLongest ? 'detail-stage--main' : ''}`}>
        <span className="detail-stage-name">{label}{' '}{d.list}</span>{' '}
        <span className="detail-stage-value">
        {ct}
        {showBlockerInfo && !!blockedList && (
          <span className="detail-stage-blocked">
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
          </span>
        )}
        </span>
      </p>
    );
  }

  render() {
    const { show, data } = this.state;
    const { cards, efficiency } = data;
    const { blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';
    
    const cycleTime = data.cycleTime && `${data.cycleTime} ${data.cycleTime > 1 ? 'days': 'day'}`;

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        {!show || !cards ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <div className='box_white_title mb-4'>
              <DetailStats
                stats={[
                  { label: 'Flow efficiency', value: `${efficiency}%` },
                  cycleTime ? { label: 'Cycle time', value: cycleTime } : { label: 'Frequency', value: cards.length }
                ]}
              />
              <div className='right-actions'>
                <Button variant='secondary' size='sm' className="btn-action" onClick={this.handleClose}>
                  <img src={closeIcon} alt="close" />
                </Button>
              </div>
            </div>
          
            <Accordion>
              {cards.map((card, i) => {
                const stages = card.details.map(d => ({ d, blockedList: _.find(card.card.blockedLists, { listId: d.listId }) }));
                const longest = _.maxBy(stages, stage => stageTime(stage.d, stage.blockedList, blockedTime));
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0} className={showBlockerInfo && !!card.card.blockedTime && 'accordion-item-blocked-card'}>
                    <Accordion.Header>
                      <span className={`label_dot ${isWhite(card.color) ? 'label_dot--white' : ''}`} style={{ background: card.color }} />
                      {card.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!card.card.secondaryName && <p className="detail-summary">{card.card.secondaryName}</p>}
                      <p className="detail-meta">
                        {!!card.card.coloredField && <span>{card.card.coloredValue}</span>}
                        <span>{card.totalTime ?
                          formatWorkDuration(card.totalTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays):
                          formatWorkDuration(_.sumBy(card.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                      </p>
                      {showBlockerInfo && blockedTime === 'all' && !!card.card.blockedTime && (
                        <p className='block-item'>
                          <span className="detail-label">Blocked time:</span>{' '}<span className="detail-value">{formatWorkDuration(card.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                        </p>
                      )}
                      {stages.map((stage, y) => {
                        return this.renderDetail(stage.d, y, stage.blockedList, blockedTime, label, blockers, stage === longest);
                      })}
                      {!!card.card.url && (
                        <p>
                          <a href={card.card.url} target="_blank" className='btn btn-sm btn-light-secondary'>
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(FEDetailsAccordion);
